// @flow
import DataTable from '../data_table/data_table'
import {snakeCase, isEqual} from 'lodash-es'
import type FilterContext from '../data_table/filter_context'

export default class TabbedDataTable extends DataTable {

    constructor(id: number, component_name: string, options: any, extra_params: {}) {
        super(id, component_name, options, extra_params);
        $(this.component).find('[data-toggle="tab"]').on('shown.bs.tab', function() {
            let $target = $($(this).attr('href'));
            $target.find('.dataTables_scrollBody table').DataTable().draw();
        });
    }

    load() {
        let self = this;
        let description = self.filterContext.getDescription();
        if (this.params && isEqual(description, this.params)) return;
        this.params = Object.assign( {}, this.getParams(), description );
        $.getJSON(this.options.controller, this.params, (response) => {
            if (self.dismounting) return;

            self.finishedLoading();
            let $component = $(self.component);
            self.clear();
            
            let tabIndex = 0;
            for (const tabName of Object.keys(response)) {
                let tableData = response[tabName]
                let tabClass = `.tab-${tabIndex}`
                let options = self.getDefaultOptions(tableData);
                tableData.columns.forEach(column => {
                    $component.find(tabClass).find('.headers').append(
                        `<th class="col_${snakeCase(column[0])}">${column[0]}</th>`);
                    self.handleFormatters(column, options, $component);
                });
                if (self.dismounting) return;
                self.filterContext.table = $(self.component).find(tabClass).DataTable(options);
                self.filterContext.columnIndexes = self.columnIndexes;
                self.filterContext.apply();
                self.addIcons();
                $component.find('.action-wrapper').show();
                tabIndex++;

            }
        })
    }
}
